document.addEventListener("DOMContentLoaded", function() {
    
    const logos = document.querySelectorAll('.logo');
    
    logos.forEach(logo => {
        logo.style.cursor = "pointer";
        
        logo.addEventListener('click', function() {
            window.location.href = "https://c1ztuf-w9.myshopify.com/";
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    
    // Dono classes ko target kar rahe hain
    const logos = document.querySelectorAll('.logo, .kznsa-logo');
    
    logos.forEach(logo => {
        logo.style.cursor = "pointer";   // Clickable hone ka feel
        
        logo.addEventListener('click', function() {
            window.location.href = "https://c1ztuf-w9.myshopify.com/";
        });
    });
});